// AWS Cognito Configuration
const getRedirectUri = () => {
	const currentUrl = window.location.origin;
	if (currentUrl.includes("localhost:3000")) {
		return "http://localhost:3000/";
	} else if (
		currentUrl.includes("parts-planning.productionanalytics-dev.rio.cloud")
	) {
		return "https://parts-planning.productionanalytics-dev.rio.cloud/";
	} else if (
		currentUrl.includes(
			"parts-planning-development.productionanalytics-dev.rio.cloud",
		)
	) {
		return "https://parts-planning-development.productionanalytics-dev.rio.cloud/";
	}

	return currentUrl + "/"; // Fallback to current origin
};

const authConfig = {
	cognitoDomain:
		"man-parts-user-pool-domain-eu-west-1-dev.auth.eu-west-1.amazoncognito.com", // Replace with your Cognito domain
	clientId: "5diioraj86duletiiv18gkkb7f", // Replace with your Cognito App Client ID
	redirectUri: getRedirectUri(), // Dynamic redirect URI based on current origins
};

export default authConfig;
